<div class="events-page">
  <div class="page-header">
    <h1 class="bold-24">{{ 'events' | transloco }}</h1>
    <button class="primary-bar-btn" (click)="createEvent()">
      <span>{{ 'createEvent' | transloco }}</span>
    </button>
  </div>

  <!-- Tabs -->
  <div class="tabs-container">
    <button
      class="tab-button"
      [class.active]="currentTab() === 'participant'"
      (click)="selectTab('participant')">
      {{ 'myEvents' | transloco }}
    </button>
    <button
      class="tab-button"
      [class.active]="currentTab() === 'active'"
      (click)="selectTab('active')">
      {{ 'active' | transloco }}
    </button>
    <button
      class="tab-button"
      [class.active]="currentTab() === 'mine'"
      (click)="selectTab('mine')">
      {{ 'created' | transloco }}
    </button>
  </div>

  <!-- Search -->
  <div class="search-container">
    <input
      type="text"
      class="search-input"
      [formControl]="searchControl"
      [placeholder]="'searchEvents' | transloco">
  </div>

  <!-- Loading State -->
  @if (isLoading()) {
    <div class="loading-container">
      <div class="spinner"></div>
    </div>
  }

  <!-- Events List -->
  @if (!isLoading()) {
    <div class="events-grid">
      @if (filteredEvents().length === 0) {
        <div class="empty-state">
          <p class="regular-16">{{ 'noEventsFound' | transloco }}</p>
        </div>
      }

      @for (event of filteredEvents(); track event.id) {
        <app-event-card
          [event]="event"
          [showActions]="event.mine"
          (click)="viewEvent(event)"
          (edit)="editEvent(event)"
          (delete)="openDeleteModal(event)">
        </app-event-card>
      }
    </div>
  }

  <!-- Delete Confirmation Modal -->
  @if (showDeleteModal()) {
    <app-modal
      [title]="'deleteEvent' | transloco"
      [footerButtons]="deleteModalButtons"
      (closeEvent)="showDeleteModal.set(false)">
      <p>{{ 'confirmDeleteEvent' | transloco }}</p>
    </app-modal>
  }
</div>


